import actions from "@/store/modules/contract-model/actions";
import mutations from "@/store/modules/contract-model/mutations";
import state from "@/store/modules/contract-model/state";

export default {
    actions,
    mutations,
    state
}